import { Box, Checkbox, Drawer, IconButton, makeStyles, Typography } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useState } from "react";
import SearchTextField from "src/components/TextField/SearchTextField";
import { tokenHistoryTitles } from "src/config/constants";
import useNotify from "src/hooks/useNotify";
import useSearchData from "src/hooks/useSearchData";

const useStyle = makeStyles((theme) => ({
  title: {
    color: theme.palette.text.hint,
  },
  text: {
    color: theme.palette.text.disabled,
  },
  paper: {
    padding: "1rem",
    borderRadius: (props) => {
      if (props.anchor === "bottom") return "16px 16px 0px 0px";
      else if (props.anchor === "right" || props.anchor === "left") return "0px";
      else return "0px 0px 16px 16px";
    },
  },
}));

export const searchType = (element, index, searchText) => {
  const temp = searchText
    .toString()
    .toLowerCase()
    .match(/\b(\w+)\b/g);
  var check = true;
  const realSearchText = [].concat(temp);
  if (realSearchText.length === 0) return true;
  for (let i = 0; i < realSearchText.length; i++) {
    if (!element.toString().toLowerCase().includes(realSearchText[i])) check = false;
  }
  return check;
};

export default function SelectedTypeDrawer({ selectedTypes, setSelectedTypes }) {
  const cls = useStyle();
  const { warnNotify } = useNotify();
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const filteredType = Object.keys(tokenHistoryTitles).slice(1);
  const searchData = useSearchData(filteredType, searchText, searchType);

  const toggleItem = (e, type) => {
    e.stopPropagation();
    if (selectedTypes.includes(type)) {
      if (selectedTypes.length > 1) {
        selectedTypes = selectedTypes.filter((item) => item !== type);
      } else return;
    } else if (selectedTypes.length < 5) selectedTypes.push(type);
    else warnNotify("You only can choose less than or equal 5 items");
    setSelectedTypes([...selectedTypes]);
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={() => setOpen(true)} size="small">
          <MoreVertIcon fontSize="25px" />
        </IconButton>
      </Box>
      <Drawer open={open} onClose={() => setOpen(false)} classes={{ paper: cls.paper }} anchor="right">
        <Box mb={2}>
          <Typography variant="h2" className={cls.title}>
            Select Type
          </Typography>
        </Box>
        <SearchTextField
          placeholder="Search type..."
          variant="outlined"
          value={searchText}
          event={{ onChange: (value) => setSearchText(value), onClear: () => setSearchText("") }}
          style={{ marginBottom: "0.75rem" }}
        />
        {searchData.map((item, index) => (
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            key={index}
            onClick={(e) => toggleItem(e, item)}
            style={{ cursor: "pointer" }}
          >
            <Checkbox color="primary" checked={selectedTypes.includes(item)} />
            <Typography className={cls.text}>{tokenHistoryTitles[item]}</Typography>
          </Box>
        ))}
      </Drawer>
    </>
  );
}
